import React, { useEffect, useState } from 'react';
import { MapPin, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Valentina',
  city: 'Buenos Aires'
}, {
  name: 'Camila',
  city: 'Córdoba'
}, {
  name: 'Sofía',
  city: 'Rosario'
}, {
  name: 'Martina',
  city: 'Mendoza'
}, {
  name: 'Lucía',
  city: 'La Plata'
}, {
  name: 'Florencia',
  city: 'Mar del Plata'
}, {
  name: 'Agustina',
  city: 'Tucumán'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    // Initial delay before showing first popup
    const initialDelay = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 10-20 seconds
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextBuyer, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-252">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-soft border border-brand-pastelpink p-4 max-w-[300px] flex items-start gap-3" data-id="element-253">
          <div className="bg-brand-lilac p-2 rounded-full flex-shrink-0 mt-1" data-id="element-254">
            <MapPin size={16} className="text-brand-pink" data-id="element-255" />
          </div>
          <div data-id="element-256">
            <p className="text-sm font-medium text-brand-black" data-id="element-257">
              <span className="font-bold" data-id="element-258">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-259">
              Acaba de comprar Barre Resuelto
            </p>
            <p className="text-[10px] text-brand-pink mt-1 font-medium" data-id="element-260">
              Hace unos minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-261">
            <X size={14} data-id="element-262" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}